import React, { Component } from "react";
import AnalyticsPage from "../../Components/Seller/Analytics";

export class Analytics extends Component {
  componentDidMount() {
    const { getTopsellingProductRequest } = this.props;
    getTopsellingProductRequest();
  }
  render() {    
    const { TopsellingProduct } = this.props;
    return (
      <>
        <AnalyticsPage TopsellingProduct={TopsellingProduct}    />
      </>
    );
  }
}

export default Analytics;
